import { DOMAIN_NAME } from "./Domain";

export const FolderArchitecture = [{
    'label': 'Accounting',
    'rcode': 'system_restriction_code_accounting_department'
},{
    'label': 'Accounts Receivable',
    'rcode': 'system_restriction_code_ar_department'
},{
    'label': 'Consulting',
    'rcode': 'system_restriction_code_consulting_department'
},{
    'label': 'Management Consulting Group',
    'rcode': 'system_restriction_code_mcg_department'
},{
    'label': 'Payroll',
    'rcode': 'system_restriction_code_payroll_department'
},{
    'label': 'Retirement Plan Administration',
    'rcode': 'system_restriction_code_rpa_department'
},{
    'label': 'Tax',
    'rcode': 'system_restriction_code_tax_department'
}];

export default FolderArchitecture;
